/* References
* AWS SQS https://docs.aws.amazon.com/AWSJavaScriptSDK/v3/latest/client/sqs/command/SendMessageCommand/
* AWS Cognito https://docs.aws.amazon.com/es_es/sdk-for-javascript/v3/developer-guide/loading-browser-credentials-cognito.html
*/
import { SQSClient, SendMessageCommand } from "@aws-sdk/client-sqs";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";
import Service from './abstract';

const AWS_REGION = process.env.REACT_APP_AWS_REGION
const AWS_IDENTITY_POOL_ID = process.env.REACT_APP_AWS_IDENTITY_POOL_ID
const AWS_SQS_URL = process.env.REACT_APP_AWS_SQS_URL

export const FLOW = 'sign'

export const STEPS = {
    ACTIONS: {
        FIND_SIGN: 'init.find-sign',
        FIND_CONTRACT: 'page.contract.find-contract',
        DOWNLOAD_CONTRACT: 'page.contract.download-contract',
        SUBMIT_SELFIE: 'page.selfie-special.login',
        SUBMIT_DNI: 'page.selfie-special.submit-dni',
        SUBMIT_SIGN: 'page.sign.submit-sign',
    },
    PAGES: {
        WELCOME: 'page.welcome',
        CONTRACT: 'page.contract',
        DNI: 'page.documents',
        SELFIE_NEUTRAL: 'page.selfie-neutral',
        SELFIE_SPECIAL: 'page.selfie-special',
        DIGITAL_SIGN: 'page.sign',
        END: 'page.success',
    }
};

function parseError (error) {
    const errorParsed = {};
    errorParsed.code = error.code || 500;
    errorParsed.name = error.name;
    errorParsed.message = error.message;
    errorParsed.stack = error.stack;
    errorParsed.extra = error.extra;
    return errorParsed;
};

const sqs = new SQSClient({ 
    apiVersion: '2012-11-05', 
    region: AWS_REGION,
    credentials: fromCognitoIdentityPool({
        clientConfig: { region: AWS_REGION },
        identityPoolId: AWS_IDENTITY_POOL_ID
    }),
}); 

export class LoanEvents extends Service {
    flow = FLOW
    steps = STEPS
    service = 'WEB02'
    trace
    
    constructor () {
        super('cuotitasstores/loanevents')
    }

    // point to local cuotitasstores microservice
    // get baseURL() {
    //     return `http://localhost:64055/loanevents`
    // }

    async findTrace({ id_loan_offer, id_loan_request, id_sign_request, id_store_request_loan, hash }) {
        const params = {};

        if (id_loan_offer) {
            params.id_loan_request = id_loan_offer;
        }
        if (id_loan_request) {
            params.id_loan_request = id_loan_request;
        }
        if (id_sign_request) {
            params.id_sign_request = id_sign_request;
        }
        if (id_store_request_loan) {
            params.id_sign_request = id_store_request_loan;
        }
        if (hash) {
            params.hash = hash
        }

        const response = await this.get('/trace', { params });
        
        if (!response.success) {
            throw new Error('Could not find trace');
        }

        return response.trace;
    }

    async step(step, body) {
        if(!step) return
        try {
            if (!this.trace) {
                this.trace = await this.findTrace(body);
            }

            const flow = this.flow;
            const trace = this.trace;

            const url = `/traces/${trace}/${flow}/${step}`;

            await sqs.send(new SendMessageCommand({
                MessageBody: JSON.stringify({ url, body }),
                MessageDeduplicationId: `${Date.now()}${(Math.round(Math.random() * 100)).toString().padStart(3, '0')}`,
                QueueUrl: AWS_SQS_URL,
                MessageGroupId: 'Group1',
            }))
        }
        catch (error) {
            console.log('[loanevents] step call error:', error)
        }
    }

    async error(step, error, body) {
        try {
            if (!this.trace) {
                this.trace = await this.findTrace(body);
            }

            const flow = this.flow;
            const trace = this.trace;
            const url = `/traces/${trace}/${flow}/${step}/error`;

            await sqs.send(new SendMessageCommand({
                MessageBody: JSON.stringify({ 
                    url, 
                    body: {
                        ...body,
                        service: { code: this.port },
                        endpoint: { name: this.endpoint },
                        error: parseError(error)
                    } 
                }),
                MessageDeduplicationId: `${Date.now()}${(Math.round(Math.random() * 100)).toString().padStart(3, '0')}`,
                QueueUrl: AWS_SQS_URL,
                MessageGroupId: 'Group1',
            }))
        }
        catch (error) {
            console.log('[loanevents] error call error:', error)
        }
    }
}
// eslint-disable-next-line import/no-anonymous-default-export
export default new LoanEvents()
